<template>
<div class="auth-layout row align-content--center">
  <div class="flex xs12 pa-3 flex-center">
    <router-link class="py-5 flex-center" to="/">

    </router-link>
  </div>

  <div class="flex xs12 pa-3">
    <div class="d-flex justify--center " >
      <va-card class="auth-layout__card">
        <va-tabs
          v-model="tabIndex"
          center
        >
          <va-tab>{{ $t('auth.login') }}</va-tab>
          <!-- <va-tab>{{ $t('auth.createNewAccount') }}</va-tab> -->
        </va-tabs>

        <va-separator/>

        <div class="pa-3">
          <router-view/>
        </div>
      </va-card>
    </div>
  </div>
</div>
</template>

<script>
import VaIconVuestic from 'vuestic-ui/src/components/vuestic-components/va-icon/va-iconset/VaIconVuestic'

const tabs = [
  'login',
  'signup',
]

export default {
  name: 'AuthLayout',
  components: { VaIconVuestic },
  data () {
    return {
      selectedTabIndex: 0,
      tabTitles: ['login', 'createNewAccount'],
    }
  },
  computed: {
    tabIndex: {
      set (tabIndex) {
        this.$router.push({ name: tabs[tabIndex] })
      },
      get () {
        return tabs.indexOf(this.$route.name)
      },
    },
  },
}
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  background-image: url("https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcSYPSLLPeJFv5PUcys4eT51rygS2XR7m_1L0YxduHh7ZolF1t3d")!important;
   background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }
}
.flex-center {
    display: initial!important;
}
.va-tabs__slider-wrapper
{
  background-color:black!important;
}
</style>
